<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps"  ref="SetBtn"></buttonlist>

        <el-table
                id="xpane-0"
                :data="dataSet"
                ref="singleTable"
                v-loading="loading"
                :highlight-current-row="true"
                border
                size="mini"
                :height="tableHeight"
                :row-class-name="tableRowClassName"
                header-row-class-name="headerclass"
                row-key="uniquenumber"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                lazy
                :load="load"
                style="width: 100%; margin-top:5px"
        >
           
            <el-table-column show-overflow-tooltip prop="uniquenumber" label="" width="80">
                <template>
                    <i class="el-icon-tickets"></i>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="ilevel" :label="$t('getapi[8148]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="schedule_no" :label="$t('getapi[4209]')"></el-table-column>
            <el-table-column fixed="left" prop="sequencenum" :label="$t('getapi[8231]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.sequencenum | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_road" :label="$t('getapi[8388]')"></el-table-column>
            <el-table-column show-overflow-tooltip fixed="left" prop="sonequencenos" :label="$t('getapi[8232]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sonequencenodesc" :label="$t('getapi[8233]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="routremark" :label="$t('getapi[12391]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="parttype" :label="$t('getapi[6117]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')">
               <!-- <template scope="scope">
                    <div v-if="scope.row.ilevel == 1" style="background: green">
                        <span>{{scope.row.part_code}}</span>
                    </div>
                    <div v-if="scope.row.ilevel != 1">
                        <span>{{scope.row.part_code}}</span>
                    </div>
                </template>-->
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="page_no" :label="$t('getapi[133]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sostatus" :label="$t('getapi[6356]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[1479]')"></el-table-column>
            <el-table-column prop="bomstdqty" :label="$t('getapi[4269]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.bomstdqty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="actual_finish_qty" :label="$t('getapi[6359]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.actual_finish_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="plan_finish_qty" :label="$t('getapi[6357]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.plan_finish_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="stockqty" :label="$t('getapi[6360]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.stockqty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="total_issue_qty" :label="$t('getapi[2874]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.total_issue_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="to_inv_qty" :label="$t('getapi[4219]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.to_inv_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="scrap_qty" :label="$t('getapi[4220]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.scrap_qty | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="finished_product_receive" :label="$t('getapi[6358]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.finished_product_receive | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="part_master_unit" :label="$t('getapi[888]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="datestr" :label="$t('getapi[4215]')"></el-table-column>
        </el-table>

        <serce :isVisible="isVisible" queryData="ProSOlayerManagement" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: '2_solevelnew',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [],
                loading: '',
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 10000, // 当前页数据量
                selectData: [],
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            // this.btnauthority();
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this
            this.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                let height = res.target
                // console.log('555'+height.scrollTop);
                this.scrollTop = height.scrollTop
            },false)
            that.authority();
        },
        activated () {   // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 20)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4004]") + '新',this.$t("getapi[25]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSOlayerManagement');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                that.$http.urlpost('/Pro/SO/GetProSOLayerManagerList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.List;
                        for(let i =0;i<that.dataSet.length;i++){
                            that.dataSet[i].hasChildren = true
                        }
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            exps(){
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Pro/SO/GetProSOLayerManagerToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                // that.btnauthority()
            },
            
            // 获取子数据
            getSonView(row){
                let that = this
                
                if(row.hasChildren == false){
                    return
                }
                let parm = {
                    so_code: row.so_code,
                    schedule_no: row.schedule_no,
                    plan_finish_qty: row.plan_finish_qty,
                    part_code: row.part_code,
                    part_version: row.part_version,
                    ilevel: row.ilevel,
                    uniquenumber: row.uniquenumber,
                    expand:row.expand,
                    parttype:row.parttype,
                }
                that.token = JSON.parse(that.userData).token;
                $.ajax({
                    url: Common.Url + '/Pro/SO/GetProSOLayerManagerChildren?token=' + that.token,
                    type: 'post',
                    async: false,
                    data: JSON.stringify(parm),
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            let data1 = res.DataContent.List
                            if(data1.length != 0){
                                for(let i = 0;i<data1.length;i++){
                                    data1[i].hasChildren = true
                                }
                                row.children = data1
                            } else {
                                row.hasChildren = true
                                row.children = []
                            }
                        } else {
                            //Message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    },
                    error: function (xhr, errorType, error) {
                        
                    }
                });
                
            },
            load(row, treeNode, resolve) {
                let that = this
                that.getSonView(row)
                // console.log('执行' + JSON.stringify(row))
                setTimeout(() => {
                    resolve(
                        row.children
                    )
                }, 1000)                
            },
            tableRowClassName({row, rowIndex}) {
                console.log(row)
                // if(row.ilevel == 1){
                //     return 'grayb'
                // }
                if(row.color == 1){
                    return 'blue'
                }
                if(row.color == 2){
                    return 'red'
                }
                if(row.color == 3){
                    return 'gray'
                }
                if(row.color == 4){
                    return 'black'
                }
                if(row.bgcolor == 1){
                    return 'aliceblue'
                }

            },
        }
    };
</script>

<style  scoped lang="less">
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
    /deep/.blue{
        color: blue;
    }
    /deep/.red{
        color: red;
    }
    /deep/.gray{
        color: #805043;
    }
    /deep/.black{
        color: black
    }
    /deep/.aliceblue{
        background: #c0fff3;
    }
    /deep/.grayb{
        background: #d9d6d5;
    }
</style>
<style>
    .el-message-box {
        width: 600px;
    }

</style>
